// @ts-strict-ignore
import { useContext } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { ButtonSize, ButtonVariant, IconName } from '@usealloy/component-library';

import { UserContext } from '~/dashboard/context';
import { useAppDispatch, useAppSelector } from '~/store/reduxHooks';

import { selectReversedLegacyActionMappings, selectReversedLegacyThresholdMappings } from 'flow/store/redux/selectors';
import { selectSelectedEvidenceThresholdId, selectThresholdOutputResults } from 'flow/store/redux/selectors/workflowFeatures';
import { setSelectedEvidenceThresholdId } from 'flow/store/redux/slice';

import { RuleBuilderContext } from '../../../context';
import { ThresholdContext } from '../context';
import { StyledEvidencesButton, StyledOutputValueWrapper } from './styles';
import ThresholdOutputValue from './ThresholdOutputValue';

export default function ThresholdResult() {
  const dispatch = useAppDispatch();
  const reversedActionMappings = useAppSelector(selectReversedLegacyActionMappings);
  const reversedThresholdMappings = useAppSelector(selectReversedLegacyThresholdMappings);
  const selectedEvidenceThresholdId = useAppSelector(selectSelectedEvidenceThresholdId);
  const thresholdOutputResults = useAppSelector(selectThresholdOutputResults);

  const { featureFlags } = useContext(UserContext);
  const { populatedThreshold } = useContext(ThresholdContext);
  const { containerType, sourceAction, thresholdResults } = useContext(RuleBuilderContext);

  const legacyActionId = reversedActionMappings[sourceAction.publicId];
  const legacyThresholdId = reversedThresholdMappings[populatedThreshold.publicId];


  if (!legacyThresholdId || (!thresholdOutputResults && !thresholdResults)) {
    return null;
  }

  const thresholdResultsBasis = featureFlags.ruleExplainabilityPhase >= 4
    ? thresholdOutputResults[legacyActionId]
    : thresholdResults;

  if (!thresholdResultsBasis) {
    return null;
  }

  const thresholdResult = thresholdResultsBasis.thresholds?.[legacyThresholdId];

  if (!thresholdResult) {
    return null;
  }

  const onClick = () => {
    const thresholdId = thresholdResult.action_threshold_id;
    if (selectedEvidenceThresholdId === thresholdId) {
      dispatch(setSelectedEvidenceThresholdId(null));
      datadogRum.addAction('explainability-evidence-close', { thresholdId });
    } else {
      dispatch(setSelectedEvidenceThresholdId(thresholdId));
      datadogRum.addAction('explainability-evidence-open', { thresholdId });
    }
  };

  const isSelectedEvidenceThresholdId = (
    selectedEvidenceThresholdId === thresholdResult.action_threshold_id
  );

  return (
    <StyledOutputValueWrapper containerType={containerType}>
      <ThresholdOutputValue thresholdResult={thresholdResult} />
      {(thresholdResult.has_evidence || thresholdResult.has_aggregation_evidence) && (
        <StyledEvidencesButton
          icon={IconName.Receipt}
          size={ButtonSize.xsmall}
          variant={ButtonVariant.tertiary}
          onClick={onClick}
          {...(isSelectedEvidenceThresholdId && {
            forceState: 'active',
          })}
        />
      )}
    </StyledOutputValueWrapper>
  );
}
